import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';
import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import React from 'react';
import classnames from 'classnames';
import { getThemeClassNames } from '@cognite/cogs-utils';
import { ActionListItem } from './action-list-item.js';
import { ActionListLinkItem } from './action-list-link-item.js';
import { ActionListSection } from './action-list-section.js';

/**
 * ActionList component can be used as a sidebar navigation or toggles for different sections.
 */
var ActionListBase = /*#__PURE__*/React.forwardRef(function (_a, ref) {
  var className = _a.className,
    inverted = _a.inverted,
    children = _a.children,
    otherProps = __rest(_a, ["className", "inverted", "children"]);
  return jsx("div", Object.assign({
    ref: ref,
    className: classnames.apply(undefined, ['cogs-lab', 'cogs-actionlist'].concat(_toConsumableArray(getThemeClassNames(inverted)), [className])),
    role: "navigation"
  }, otherProps, {
    children: children
  }));
});
var ActionList =
// eslint-disable-next-line prefer-object-spread
Object.assign({}, ActionListBase, {
  Item: ActionListItem,
  LinkItem: ActionListLinkItem,
  Section: ActionListSection
});

export { ActionList, ActionListBase };
